export default {
  highered: false,
  userType: false,
  redirect: '',
  googleAnaltyicsId: '',
  gtmId: '',
  captchaSiteKey: '',
  captchaSiteTestKey: '',
};
